import { render, staticRenderFns } from "./updateUserName.vue?vue&type=template&id=65265402&"
import script from "./updateUserName.vue?vue&type=script&lang=js&"
export * from "./updateUserName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/system/updateUserName.vue"
export default component.exports